/**
 * Sector Operations — Stays Group View & Template Push Service (R39 K11.b / SO-P125).
 * Client service wrapping callables for group scorecard and multi-property template pushes.
 */

import { callable } from './callable'
import type {
  GetStaysGroupViewInput,
  StaysGroupViewResult,
  PushStaysGroupTemplateInput,
  PushStaysGroupTemplateResult,
} from '../types/ops'

export async function getStaysGroupView(
  input: GetStaysGroupViewInput,
): Promise<StaysGroupViewResult> {
  return callable<GetStaysGroupViewInput, StaysGroupViewResult>(
    'getStaysGroupView',
    input,
  )
}

export async function pushStaysGroupTemplate(
  input: PushStaysGroupTemplateInput,
): Promise<PushStaysGroupTemplateResult> {
  return callable<PushStaysGroupTemplateInput, PushStaysGroupTemplateResult>(
    'pushStaysGroupTemplate',
    input,
  )
}
